/*
 * Project: BookingEngine
 * Module: components/booking/rooms/CartDiscount.js
 * vim:ft=javascript.jsx:
 * @flow
 */
import React from 'react';
import PropTypes from 'prop-types';
import { calculateDiscount } from '../../../actions/Booking';

const CartDiscount = ({ amount, amountBefore, additionalDiscount }, context) => {
  const discount = calculateDiscount(amount, amountBefore) + additionalDiscount;
  if (discount <= 0) {
    return null;
  }
  return (
    <div className="room-amounts__discount">
      {`-${discount < 10 ? ' ' : ''}${discount}%`}
      <div className="discount-text">
        <span>{context.t('discount')}</span>
        <span>{context.t('applied')}</span>
      </div>
    </div>
  );
};

CartDiscount.propTypes = {
  amount: PropTypes.number.isRequired,
  amountBefore: PropTypes.number.isRequired,
  additionalDiscount: PropTypes.number.isRequired,
};

CartDiscount.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default CartDiscount;
